namespace $.$$ {

	export class $shm_hitalama_map_widget_float_notebook2 extends $.$shm_hitalama_map_widget_float_notebook2 {

		links( next?: string[] ) {
			if( next === undefined ) return this.widget().widgets().map( widget => widget.link_str() ) ?? []
			this.widget().widgets(
				next.map( link => this.Map_page().widget_by_link( new $giper_baza_link( link ) ) )
			)
			return next
		}

		insert_widget( pos: number, widget: $shm_hitalama_map_widget ) {
			this.links_splice( pos, [ widget.link_str() ] )
		}

		links_splice( pos: number, links_changed: string[] ) {
			return $$.$shm_hitalama_map_widget_float_layout_vert.prototype.links_splice.call(
				this,
				pos,
				links_changed,
			)
		}

		Adds(): $.$shm_hitalama_map_widget_float_notebook2_adds {
			const obj = super.Adds()
			obj.Notebook = ()=> this
			return obj
		}

	}

}
